<template>
  <mds-section
    collapsible
    border="none"
    :size="7"
    :expanded="expanded"
    :title="translate('detail')"
    :class="$style['details-section']"
    @mds-section-expanded="$emit('update:expanded', true)"
    @mds-section-closed="$emit('update:expanded', false)"
  >
    <div v-if="metadataItems.length > 0" :class="$style['metadata-list']">
      <span
        v-for="(metadata, index) in metadataItems"
        :key="`metadata-${index}`"
        :class="$style['metadata-list__item']"
      >
        <slot name="metadata" :metadata="metadata">
          <span>{{ metadata }}</span>
        </slot>
      </span>
    </div>
    <slot></slot>
  </mds-section>
</template>
<script>
import MdsSection from '@mds/section';

export default {
  name: 'fee-schedule-details-section',
  components: {
    MdsSection,
  },
  model: {
    prop: 'expanded',
    event: 'update:expanded',
  },
  inject: ['translate'],
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    metadataItems: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" module>
@import '@mds/constants';
@import '@mds/typography';
@import '@mds/link';
@import '../styles/fee-schedule-item.scss';

.details-section {
  .mds-section__content {
    padding: 0 $mds-space-2-x $mds-space-2-x $mds-space-2-x;
  }
}
</style>
